import { apiClient } from "./authService";

const LEGACY_UPLOADS_BASE_URL =
  "http://ec2-3-15-170-84.us-east-2.compute.amazonaws.com:4500/uploads/";

const isAbsoluteUrl = (value: string) => /^https?:\/\//i.test(value);

const buildLegacyUploadsUrl = (value: string) => {
  const sanitized = value.replace(/^\/+/, "");
  return `${LEGACY_UPLOADS_BASE_URL}${sanitized}`;
};

const parseFileNameFromContentDisposition = (
  header?: string
): string | undefined => {
  if (!header) return undefined;

  const filenameStarMatch = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (filenameStarMatch && filenameStarMatch[1]) {
    try {
      return decodeURIComponent(filenameStarMatch[1]);
    } catch {
      return filenameStarMatch[1];
    }
  }

  const filenameMatch = header.match(/filename="?([^";]+)"?/i);
  if (filenameMatch && filenameMatch[1]) {
    return filenameMatch[1];
  }

  return undefined;
};

export const getAttachmentFileUrl = (attachment?: {
  file?: string | null;
  file_url?: string | null;
}): string | undefined => {
  if (!attachment) return undefined;

  const candidate =
    (typeof attachment.file_url === "string" && attachment.file_url.trim()) ||
    (typeof attachment.file === "string" && attachment.file.trim()) ||
    undefined;

  if (!candidate) {
    return undefined;
  }

  return isAbsoluteUrl(candidate) ? candidate : buildLegacyUploadsUrl(candidate);
};

export const downloadAttachmentFile = async (
  attachmentId: string | number
): Promise<{
  blob: Blob;
  fileName?: string;
  contentType?: string;
}> => {
  const response = await apiClient.get(`/attachments/download/${attachmentId}`, {
    responseType: "blob",
  });

  const contentDisposition =
    (response.headers &&
      ((response.headers["content-disposition"] as string) ||
        (response.headers["Content-Disposition"] as string))) ||
    undefined;

  const contentType =
    (response.headers &&
      ((response.headers["content-type"] as string) ||
        (response.headers["Content-Type"] as string))) ||
    undefined;

  return {
    blob: response.data as Blob,
    fileName: parseFileNameFromContentDisposition(contentDisposition),
    contentType,
  };
};

export const createAttachment = async (
  clientId: string | number,
  file: File,
  title: string,
  notes: string
): Promise<any> => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", title);
    formData.append("notes", notes);

    const response = await apiClient.post(
      `/attachments/create/client/${clientId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getClientAttachments = async (
  clientId: string | number
): Promise<any> => {
  try {
    const response = await apiClient.get(`/attachments/client/${clientId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAttachment = async (
  attachmentId: string | number
): Promise<any> => {
  try {
    const response = await apiClient.delete(
      `/attachments/delete/${attachmentId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
